import { Injectable } from '@angular/core';

import { GridStackOptions } from 'gridstack';

@Injectable({
  providedIn: 'root',
})
export class GridsterConfigService {
  private getCommonConfig(): GridStackOptions {
    return {
      column: 10,
      cellHeight: '4.285rem', // * initial value -> will be recalculated
      margin: '0.75rem',
      float: false,
      removable: false, // * prevent Widgets from being removed when dragged outside Grid
      minRow: 1, // * grid can grow vertically as needed
      disableResize: false,
      disableDrag: false,
      resizable: { handles: 'e,se,s,sw,w' },
      draggable: { handle: '.widget-drag-handle' },
    };
  }

  getDashboardConfig(): GridStackOptions {
    const config = this.getCommonConfig();
    return {
      ...config,
      column: 20,
      minRow: 2,
    };
  }

  getFeedConfig(): GridStackOptions {
    const config = this.getCommonConfig();
    return {
      ...config,
      column: 10,
      minRow: 5,
    };
  }
}
